import { MonthSchema as InnerMonthSchema } from "../base/time-schema";
/** 月(１月~１２月)を表す。 */
const MonthSchema = InnerMonthSchema.brand("Month");
export const Month = {
    schema: MonthSchema,
    of(args) {
        return Month.schema.parse(args);
    },
};
//# sourceMappingURL=month.js.map